import React from 'react'
import {Button} from "primereact/button";
import PublicTournamentTreeTab from "../tournaments/PublicTournamentTreeTab";
import SpielDetailsDialog from "./SpielDetailsDialog";
import ZoomSteuerung, {useBaumZoom, ZOOM_STUFEN} from "./ZoomSteuerung";
import {useVollbild} from "./browserVollbild";
import {LeisteAusblendenKnopf, LeisteEinblendenKnopf, useLeisteAusblendbar} from "./VollbildLeisteKnoepfe";


/**
 * Turnierbaum in einem eigenen Scrollbereich, damit die Seite nicht breiter als der Bildschirm wird.
 * Gezoomt werden kann in der normalen Ansicht und im Vollbild.
 */
export default function TurnierbaumBereich(props) {

    const [vollbild, starteVollbild, schliesseVollbild] = useVollbild(props.appCall);
    // Leiste im Vollbild ausblendbar, damit mehr Platz für den Baum bleibt
    const [leisteAus, setLeisteAus] = useLeisteAusblendbar(vollbild);
    // gleicher Zoom in der normalen Ansicht und im Vollbild, auf Handys startet er bei 75 %
    const [zoomIndex, setZoomIndex] = useBaumZoom();

    const baum = <PublicTournamentTreeTab tournament={props.tournament} model={props.model}
                                          boardGames={props.boardGames} liveGames={props.liveGames}
                                          boardReihenfolge={props.boardReihenfolge}
                                          tournamentBeschreibungen={props.tournamentBeschreibungen}
                                          spielDetailsDialog={SpielDetailsDialog}/>;

    if (vollbild) {
        return <div className={"dhpt-vollbild" + (leisteAus ? " dhpt-vollbild-ohne-leiste" : "")} role="dialog" aria-modal="true" aria-label="Turnierbaum im Vollbild">
            {leisteAus && <LeisteEinblendenKnopf oben={true} onClick={() => setLeisteAus(false)}/>}
            <div className={"dhpt-vollbild-leiste" + (leisteAus ? " dhpt-ausgeblendet" : "")}>
                <span className="dhpt-vollbild-titel">{props.tournament.bezeichnung}</span>
                <ZoomSteuerung zoomIndex={zoomIndex} setZoomIndex={setZoomIndex}/>
                <LeisteAusblendenKnopf onClick={() => setLeisteAus(true)}/>
                <Button icon="pi pi-times" label="Schließen" className="p-button-secondary" onClick={schliesseVollbild}/>
            </div>
            <div className="dhpt-vollbild-inhalt">
                <div style={{zoom: ZOOM_STUFEN[zoomIndex]}}>{baum}</div>
            </div>
        </div>
    }

    return <div>
        <div className="dhpt-baum-leiste">
            <ZoomSteuerung zoomIndex={zoomIndex} setZoomIndex={setZoomIndex} klein={true}/>
            <Button icon="pi pi-window-maximize" label="Vollbild" className="p-button-sm p-button-outlined dhpt-button-hell" onClick={starteVollbild}/>
        </div>
        <div className="dhpt-baum"><div style={{zoom: ZOOM_STUFEN[zoomIndex]}}>{baum}</div></div>
    </div>
}
